
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.812.629a2.148 2.148 0 00-3.038 0L1.26 9.143a.477.477 0 00-.123.21l-1.12 4.042a.477.477 0 00.588.588l4.042-1.12a.477.477 0 00.21-.123l8.515-8.514a2.15 2.15 0 000-3.037l-.56-.56zM2.3 9.453l6.968-6.968 2.248 2.247-6.97 6.969L2.3 9.453zm-.45.901l1.796 1.796-2.483.688.688-2.484zm10.847-6.803l-.506.506L9.943 1.81l.507-.506a1.193 1.193 0 011.687 0l.56.56a1.195 1.195 0 010 1.687z","fill":"currentColor"}})])
          )
        }
      }
    